import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';
import { colors, radius } from '../../styles/tokens';

interface ContainerProps {
  isFocused: boolean;
  isErrored: boolean;
}

interface InputProps {
  labelColor?: string;
}

export const Container = styled.div<InputProps>`
  flex: 1;

  span {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${props =>
      props.labelColor ? props.labelColor : colors.onSurfaceVariant};
    margin-left: 4px;
    line-height: 20px;
  }

  @media (max-width: 1199px) {
    width: 100%;
  }
`;

export const ContainerInput = styled.div<ContainerProps>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: border-color 0.2s;
  background-color: ${colors.surfaceContainerHigh};

  height: 48px;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};

  @media (max-width: 1199px) {
    height: 44px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.primary};
    `}
`;

export const Input = styled.input`
  display: flex;
  flex: 1;
  padding: 0 16px;
  width: calc(100% - 32px);
  border: none;
  background-color: transparent;

  color: ${colors.onSurface};

  font-size: 16px;
  font-weight: 400;

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }

  /* Remove os spinners nativos de input[type=number] -- pedido
     explícito na tela de medidas, mas não faz sentido em nenhum
     outro campo numérico do app também (não tem input que se
     beneficie de incrementar em 1 clicando numa setinha). */
  &[type='number'] {
    -moz-appearance: textfield;
  }

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ContainerError = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;

  span {
    color: ${colors.error};
  }
`;

export const ContainerSuccess = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;

  span {
    color: #32a54a;
  }
`;

export const Info = styled(Tooltip)`
  height: 20px;
  margin: 0 12px;
  position: absolute;
  right: 0;

  svg {
    margin: 0;
  }

  span {
    background: ${colors.primary};
    color: ${colors.onPrimary};

    &::before {
      border-color: ${colors.primary} transparent;
    }
  }
`;
